"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essIncomingBatchesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const AuthoredEvidence = __importStar(require("../../../../composite/evidence-2/authored-evidence/authored-evidence"));
const evidence_1 = require("../../../../composite/evidence-2/evidence");
const batches_fields_1 = require("./batches-fields");
const batches_columns_1 = require("./batches-columns");
const lodash_1 = require("lodash");
const batches_table_toolbar_1 = require("./batches-table-toolbar");
const batches_detail_toolbar_1 = require("./batches-detail-toolbar");
function essIncomingBatchesFactory(url, reportTag) {
    return function IncomingBatches() {
        const intl = react_intl_1.useIntl();
        const evidence = AuthoredEvidence.useAuthoredEvidence({
            version: 2,
            identifier: 'ESS_INCOMING_BATCHES',
            apiProps: {
                url,
            },
            tableProps: {
                columns: batches_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'ESS_INCOMING_BATCHES_TABLE_TITLE',
                    defaultMessage: 'Příchozí dávky',
                }),
                toolbarProps: {
                    after: react_1.default.createElement(batches_table_toolbar_1.IncomingBatchesTableToolbar, { url: url }),
                },
                reportTag,
            },
            detailProps: {
                FieldsComponent: batches_fields_1.IncomingBatchesFields,
                toolbarProps: {
                    after: react_1.default.createElement(batches_detail_toolbar_1.IncomingBatchesToolbar, { url: url }),
                    showButton: lodash_1.stubFalse,
                    showBtn: lodash_1.stubFalse,
                    title: intl.formatMessage({
                        id: 'ESS_INCOMING_BATCHES_DETAIL_TITLE',
                        defaultMessage: 'Příchozí dávka',
                    }),
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.essIncomingBatchesFactory = essIncomingBatchesFactory;
//# sourceMappingURL=batches.js.map